<h2>{{title}}</h2>
<form [formGroup]="optionPurchase">
  <div class="form-inputs form-padding">
    <p>Item description <span class="required">*</span></p>
    <app-text-input
      [maxCharCount]="1500"
      [control]="DescriptionControl"
      placeHolderText="e.g. 10ml of Sodium Nitrate"
      class="text-field"
    ></app-text-input>
  </div>
  <div class="form-inputs form-padding">
    <p>Unit of Measurement (UoM) <span class="required">*</span></p>
    <ng-select
      [items]="UOMdropdown"
      bindLabel="value"
      appearance="outline"
      (change)="CalculateEastimateCost($event)"
      formControlName="UnitOfMeasurement"
    >
    </ng-select>
  </div>
  <div class="form-inputs form-padding">
    <p>Quantity <span class="required">*</span></p>
    <input
      class="option-purchase-input"
      type="number"
      min="0"
      max="999999"
      formControlName="Quantity"
      step="0.01"
      [placeholder]="0"
      (change)="CalculateEastimateCost($event)"
      (input)="restrictNegativeNumberInput($event, 3)"
    />
  </div>
  <div class="curr-block">
    <div class="form-inputs form-dropdown">
      <p>Currency<span class="required">*</span></p>
      <ng-select
        [items]="Currdropdown"
        appearance="outline"
        bindLabel="value"
        (change)="CalculateEastimateCost($event)"
        formControlName="Currency"
        class="currency"
      ></ng-select>
    </div>
    <div class="curr-price">
      <p>Estimated unit price <span class="required">*</span></p>
      <input
        class="option-purchase-input"
        type="number"
        min="0"
        max="999999"
        formControlName="UnitPrice"
        step="0.001"
        [placeholder]="0.0"
        (change)="CalculateEastimateCost($event)"
        (input)="restrictNegativeNumberInput($event, 2)"
      />
    </div>
  </div>
  <div class="curr-price-msg">
    <p class="curr-price-amt">Estimated item amount: {{ totalPrice }}</p>
  </div>
  <div class="form-inputs form-padding">
    <p>Duration *</p>
    <div class="duration-block">
      <div class="input-block">
        <input
          class="option-purchase-input"
          type="number"
          min="0"
          max="999999"
          step="1"
          [placeholder]="0"
          formControlName="DurationYears"
        />
        <span>Years</span>
      </div>
      <div class="input-block">
        <input
          class="option-purchase-input"
          type="number"
          min="0"
          max="999999"
          step="1"
          [placeholder]="0"
          formControlName="DurationMonths"
        />
        <span>Months</span>
      </div>
    </div>
  </div>
  <div class="actionBtns">
    <app-button
      name="Add"
      type="flat-button"
      tabindex="0"
      (keypress)="addOptionToPurchase()"
      (click)="addOptionToPurchase()"
    ></app-button>
    <app-button
      class="emptyBtn"
      name="Cancel"
      tabindex="0"
      (keypress)="optionPurchaseNav.close()"
      (click)="optionPurchaseNav.close()"
    ></app-button>
  </div>
</form>
